import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  isLoadManagers: false,
  isLoadRestau4: false,
  errorRestau4: "",
  managers: [],
  managersSearchResult: null,
  conversationsRestau: null,
};

const getters = {
  isLoadManagers: state => state.isLoadManagers,
  isLoadRestau4: state => state.isLoadRestau4,
  errorRestau4: state => state.errorRestau4,
  managers: state => state.managers,
};

const mutations = {
  getManagersSuccess(state, payload) {
    state.isLoadManagers = true;
    state.managers = payload.managers;
  },
  addManagerSuccess(state, payload) {
    state.isLoadManagers = true;
    let managers = state.managers;
    managers.push(payload.data);
    state.managers = managers;
  },
  editManagerSuccess(state, payload) {
    state.isLoadManagers = true;
    console.log({ payload });
    // let managers = state.managers;
    state.managers = payload.managers;
    // let newManagers = [];
    // managers.map((pack, index) => {
    //   if (pack._id == payload.data._id) {
    //     newManagers.push({ ...payload.data });
    //   } else {
    //     newManagers.push({ ...pack });
    //   }
    // });

    // state.managers = [...newManagers];
  },
  deleteManagerSuccess(state, payload) {
    state.isLoadManagers = true;
    let managers = state.managers;

    let newManagers = [];
    managers.map((pack, index) => {
      if (pack._id != payload.data._id) {
        newManagers.push({ ...pack });
      }
    });
    state.managers = [...newManagers];
  },
  getManagersError(state, error) {
    state.isLoadManagers = false;
    state.errorRestau4 = error;
  },

  addManagerError(state, error) {
    state.isLoadManagers = false;
    state.errorRestau4 = error;
  }
};

const actions = {
  getManagers({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    axios
      .get(`${apiPath}/managers/${payload}`, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getManagersSuccess", {
            managers: res.data
          });
        } else {
          commit("getManagersError", "error:getManagers");
        }
      });
  },

  addManager({ commit }, payload) {
    return axios
      .post(`${apiPath}/managers`, payload, config)
      .then(r => r)
      .catch(r => r);
    // .then(res => {
    //   if (res.ok) {
    //     commit("addManagerSuccess", res);
    //   } else {
    //     commit("addManagerError", "error:addManager");
    //   }
    //   return res;
    // });
  },
  editManager({ commit }, payload) {
    return axios
      .put(`${apiPath}/managers`, payload, config)
      .then(r => r)
      .catch(r => r);
  },
  deleteManager({ commit }, payload) {
    // console.table(payload);
    config.data = payload;
    console.table(config);
    return axios
      .delete(`${apiPath}/managers`, config)
      .then(r => r.data)
      .then(res => {
        return payload;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
